import { existings } from '@Ravnur-Inc/nanoutils/filter';
import { keyById } from '@Ravnur-Inc/nanoutils/keyBy';
import { Vue } from 'vue-class-component';

import { PRIVACIES, QAS } from '../descriptions/live-channel';
import { $thesaurus, liveChannelsService } from '../live-facade';

import { LiveChannel } from '../types/Live';

import { StandardOption } from '@/types/Component';

import './humanized-channels-prop.scss';

const CN = 'humanized-channels-prop';

class Props {
  value: string[];
  prop: keyof SubType<LiveChannel, string | boolean>;
}

export default class HumanizedChannelsProp extends Vue.with(Props) {
  private get channels(): LiveChannel[] {
    const { value: channelIds } = this;
    const { cache } = liveChannelsService;
    return existings(channelIds.map((id) => cache[id]));
  }

  private get props() {
    const { prop, channels, thesaurus } = this;

    if (!prop) {
      return [];
    }

    return channels.map((channel) => {
      const val = `${channel[prop]}`;
      return thesaurus?.[val]?.label || val;
    });
  }

  private get thesaurus(): Nullable<Dictionary<StandardOption>> {
    const { prop } = this;
    if (prop === 'privacy') {
      return keyById($thesaurus(PRIVACIES, 'live-channels'));
    }
    if (prop === 'enableQA') {
      return keyById($thesaurus(QAS, 'live-channels'));
    }
    return null;
  }

  render() {
    return <ul class={CN}>{this.props.map(this.renderItem)}</ul>;
  }

  private renderItem(info: string, idx: number) {
    return (
      <li key={idx} class={`${CN}__item`}>
        {info}
      </li>
    );
  }
}
